<template>
  <section class="section section-shaped section-lg my-0" id="loginComponent">
    <!-- <nav class="navbar navbar-light bg-graynav">
      <a class="navbar-brand" href="\">
        <img width="50" height="50" src="img/arc360_icon.png">
      </a>
    </nav> -->
    <br>
    <br>
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="spacerAbove">
        </div>
        <div >
          <b-img id="loginLabel" src="img/TopRibbon3_orange_white.png"></b-img>
        </div>
        <div class="spacerBelow">
        </div>
        <div class="col-8 col-lg-5">
          <card type="dark" shadow
                header-classes="bg-white pb-5"
                body-classes="text-light"
                class="border-0">
            <template>
              <!-- "px-lg-5 text-light py-lg-5" -->
              <div class="text-center text-light mb-2">
                <h3>Welcome</h3>
              </div>
              <div class="text-center text-muted mb-2">
                <h5>Site to Desktop - Immersive Experience</h5>
              </div>
              <form role="form">
                <base-input alternative
                            class="mb-3"
                            placeholder="Email"
                            addon-left-icon="ni ni-email-83"
                            v-model="email">
                </base-input>
                <base-input alternative
                            type="password"
                            placeholder="Password"
                            addon-left-icon="ni ni-lock-circle-open"
                            v-model="password">
                </base-input>
                <div class="text-center">
                  <base-button type="secondary" class="my-4" v-on:click="triggerSignInProcess">Sign In</base-button>
                </div>
              </form>
            </template>
            <!-- <div class="row mt-3">
            </div> -->
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password:""
    }
  },
  methods: {
    triggerSignInProcess: function() {
      const current = this
      if (current.validateSignInRequirements()) {
        let data = {
          username: current.email,
          password: current.password
        }
        current.$store.dispatch("mainStore/login", data).then(token=>{
          sessionStorage.setItem("accessToken", token)
          current.$store.commit("mainStore/storeAccessToken", token)
          current.$notify({
            group: 'notification_01',
            title: 'Login Successful',
            text: '',
            type: "success",
            duration: 1500
          });
          current.$router.push("/LandingPage")
        }).catch(error=>{
          console.log(error);
          current.$notify({
            group: 'notification_01',
            title: 'Login Failed',
            text: 'Kindly check your credentials for any mistakes.',
            type: "error"
          });
        });
      }
      else {
        current.$notify({
          group: 'notification_01',
          title: 'Login Failed',
          text: 'Kindly check your credentials for any mistakes.',
          type: "error"
        });
      }
    },
    validateSignInRequirements: function() {
      if (this.email!="" && this.password!="") {
        return true
      }
      else {
        return false;
      }
    }
  },
  // beforeMount() {
  //   const current = this
  //   var token = "passedlogin"
  //   sessionStorage.setItem("accessToken", token)
  //   current.$store.commit("mainStore/storeAccessToken", token)
  //   console.log("sessionStorage");
  //   console.log(sessionStorage);
  // }
};
</script>
<style>
#loginComponent {
  height: 86vh!important;
}
.spacerAbove {
  height: 24vh;
  width: 100vw!important;
}
.spacerBelow {
  height: 2vh;
  width: 100vw!important;
}
#loginLabel {
  height: 10vh!important;
}
</style>
